<template>
  <div>
    <Authenticate></Authenticate>
  </div>
</template>

<script>
import Authenticate from './Authenticate.vue';

export default {
  name: 'Home',
  components: { Authenticate },
};
</script>

<style scoped>

</style>
